
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";

const EmptyStudentsList = () => {
  return (
    <div className="flex flex-col items-center justify-center p-10 text-center border border-dashed rounded-md mt-8 bg-gray-50 dark:bg-gray-800/50">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-10 h-10 text-primary"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold mb-2">No students found</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md">
        You haven't added any students yet. Get started by adding your first
        student to track their programs and fees.
      </p>
      <Link to="/students/new">
        <Button>
          <Plus className="mr-2 h-4 w-4" />
          Add New Student
        </Button>
      </Link>
    </div>
  );
};

export default EmptyStudentsList;
